export default "__VITE_ASSET__DopHXYcm__"